<div class="content-panel">
  <h2 translate>SCHEDULE_INTERVIEW.DATE.BANNER</h2>

  <div class="well appointment-summary">
    <dl class="list-inline">
      <dt translate>SCHEDULE_INTERVIEW.LOCATION_LABEL</dt>
      <dd translate>{{location?.name}}</dd>
      @if (selectedDate) {
        <dt translate>SCHEDULE_INTERVIEW.DATE_LABEL</dt>
      }
      @if (selectedDate) {
        <dd>{{selectedDate | date}}</dd>
      }
    </dl>
  </div>


  <div class="row">
    <div class="col-12">
      <calendar-filter (filterCalendar)="onFilterCalendar($event)">
      </calendar-filter>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <a href="" data-bs-toggle="modal" data-bs-target="#helpModal" title="{{'SCHEDULE_INTERVIEW.LOCATION.MULTI_FAMILY' | translate}}" translate>SCHEDULE_INTERVIEW.LOCATION.MULTI_FAMILY</a>
    </div>
  </div>

  @if (isRemoteLocation) {
    <div class="row">
      <div class="col-12 col-md-6">
        <label for="ddlTimeZone" translate>SCHEDULE_INTERVIEW.DATE.TIME_ZONE</label>
        <select name="ddlTimeZone" id="ddlTimeZone" class="form-select" [(ngModel)]="location.tzData" (change)="refreshSchedule()">
          @for (zone of timeZones; track $index) {
            @if (zone.length > 3) {
              <option [value]="zone">{{zone}}</option>
            }
          }
        </select>
        <div style="padding-top: 10px"><i>{{'SCHEDULE_INTERVIEW.DATE.REMOTE_AVAILABILITY_WARNING' | translate}}</i></div>
        <br>
        </div>
      </div>
    }

    <div class="divider"></div>

    <div class="row">
      <div class="col-12 position-relative">
        <a tabindex="0" title="{{'SCHEDULE_INTERVIEW.DATE.PREVIOUS' | translate}}" (click)="prevMonth()" (keyup.enter)="prevMonth()" (keyup.spacebar)="$event.preventDefault(); prevMonth()" class="dhs-cal-pagination left">
          <span translate>SCHEDULE_INTERVIEW.DATE.PREVIOUS</span>
        </a>
        <a tabindex="0" title="{{'SCHEDULE_INTERVIEW.DATE.NEXT' | translate}}" (click)="nextMonth()" (keyup.enter)="nextMonth()" (keyup.spacebar)="prevMonth()" class="dhs-cal-pagination right">
          <span translate>SCHEDULE_INTERVIEW.DATE.NEXT</span>
        </a>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <app-calendar [startDate]="month1" [highlightDate]="highlightDate" [schedule]="locationSchedule" [availableAppts]="numApptFilter" (dateSelected)="onDateSelected($event)"></app-calendar>
      </div>
      <div class="col-md-6 d-none d-sm-block dhs-cal-split-line">
        <app-calendar [startDate]="month2" [highlightDate]="highlightDate" [schedule]="locationSchedule" [availableAppts]="numApptFilter" (dateSelected)="onDateSelected($event)"></app-calendar>
      </div>
    </div>
    <div class="row divider appointment-legend">
      <div class="col-md-4">
        @if (numApptFilter == 1) {
          <span class="dhs-cal-available_example"></span> <span>{{numAvailable}}</span>&nbsp;<strong translate>SCHEDULE_INTERVIEW.DATE.AVAILABLE</strong>
        }
        @if (numApptFilter > 1) {
          <span class="dhs-cal-available_example"></span> <span>{{numAvailable}}</span>&nbsp;<strong translate>SCHEDULE_INTERVIEW.DATE.AVAILABLE</strong>
        }
      </div>
      <div class="col-md-4">
        @if (numApptFilter == 1) {
          <span class="dhs-cal-full_example"></span> <span>{{numAvailable}}</span>&nbsp;<strong translate>SCHEDULE_INTERVIEW.DATE.FULL</strong>
        }
        @if (numApptFilter > 1) {
          <span class="dhs-cal-full_example"></span> <span>{{numAvailable}}</span>&nbsp;<span translate>SCHEDULE_INTERVIEW.DATE.FULL</span>
        }
      </div>
      <div class="col-md-4">
        @if (numApptFilter == 1) {
          <span class="dhs-cal-notAvailable_example"></span> <span>{{numNotAvailable}}</span>&nbsp;<strong translate>SCHEDULE_INTERVIEW.DATE.NOT_AVAILABLE</strong>
        }
        @if (numApptFilter > 1) {
          <span class="dhs-cal-notAvailable_example"></span> <strong>{{numNotAvailable}}</strong>&nbsp;<span translate>SCHEDULE_INTERVIEW.DATE.APPOINTMENTS_NOT_AVAILABLE</span>
        }
      </div>
    </div>
  </div>

  <!-- Help Modal -->
  <div id="helpModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-center" translate>MODAL.MULTI_FAMILY_TITLE</h4>
          <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div [innerHTML]="'MODAL.MULTI_FAMILY_BODY' | translate"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row justify-content-center w-100">
            <div class="col-12 col-lg-4 form-group">
              <button id="closeModal" type="button" class="btn w-100 d-block btn-primary" data-bs-dismiss="modal" translate>
                MODAL.BUTTON_CLOSE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



